const fr = {
  // Navbar
  "nav.services": "Services",
  "nav.projects": "Projets",
  "nav.calculator": "Calculateur de Coût",
  "nav.resources": "Ressources",
  "nav.process": "Processus",
  "nav.about": "À Propos",
  "nav.careers": "Carrières",
  "nav.contact": "Contact",
  "nav.blog": "Blog",
  "nav.getStarted": "Démarrer",
  "nav.siteVisit": "Visiter le Chantier",
  "nav.getQuote": "Demander un Devis",

  // Hero
  "hero.eyebrow": "Yaoundé, Cameroun",
  "hero.headline1": "Ingénierie",
  "hero.headline2": "Construite pour Durer.",
  "hero.headline3": "Services Construits pour Livrer.",
  "hero.sub": "KIVE SARL est une entreprise de construction camerounaise agréée, basée à Yaoundé, reconnue par les gouvernements, les établissements scolaires et les promoteurs privés pour la livraison de projets complexes de gestion de construction, maintenance technique et location de machinerie lourde — dans les délais, dans le budget, sans compromis.",
  "hero.cta.quote": "Demander un Devis",
  "hero.cta.services": "Nos Services",
  "stats.experience": "Années d'Expérience",
  "stats.projects": "Projets Livrés",
  "stats.engineers": "Ingénieurs Experts",
  "stats.satisfaction": "Satisfaction Client",

  // Why Choose Us
  "why.eyebrow": "Pourquoi Nous Choisir",
  "why.title": "La Différence Réside dans Notre Façon de Travailler",
  "why.sub": "Nous ne construisons pas seulement des structures — nous construisons la confiance. Chaque engagement avec KIVE SARL est défini par la rigueur, la transparence et la responsabilité qui produisent des résultats concrets.",
  "why.badge.title": "Excellence Certifiée",
  "why.badge.sub": "Reconnu par les clients publics et privés à travers le Cameroun",

  // Services
  "services.eyebrow": "Nos Services",
  "services.title": "Ce Que Nous Faisons le Mieux",
  "services.sub": "Trois disciplines clés. Une équipe responsable. Conçu pour les projets exigeants au Cameroun.",
  "services.cta.details": "Détails du Service",
  "services.cta.quote": "Demander un Devis",

  // Process
  "process.eyebrow": "Notre Méthode",
  "process.title": "Du Premier Appel à la Livraison Finale",
  "process.sub": "Un processus clair et structuré pour que vous sachiez toujours à quoi vous attendre — et quand.",
  "process.cta": "Démarrer le Processus",

  // Contact
  "contact.eyebrow": "Contactez-Nous",
  "contact.title": "Parlons de Votre Projet",
  "contact.sub": "Envoyez-nous un message et un chef de projet vous répondra dans les 24 heures.",
  "contact.info.title": "Informations de Contact",
  "contact.info.office": "Bureau",
  "contact.info.phone": "Téléphone",
  "contact.info.email": "Email",
  "contact.info.hours": "Heures d'Ouverture",
  "contact.info.officeVal": "Entrée Frazati, Damas\nYaoundé, Cameroun",
  "contact.info.phoneVal": "(+237) 677-009-408\n(+237) 675-095-808",
  "contact.info.hoursVal": "Lun–Ven : 8h00–17h00\nSamedi : 9h00–14h00",
  "contact.info.follow": "Suivez-Nous",
  "contact.form.name": "Nom Complet",
  "contact.form.email": "Adresse Email",
  "contact.form.phone": "Numéro de Téléphone",
  "contact.form.subject": "Sujet",
  "contact.form.message": "Message",
  "contact.form.send": "Envoyer le Message",
  "contact.form.sending": "Envoi en cours...",
  "contact.form.required": "obligatoire",
  "contact.success.title": "Message Reçu",
  "contact.success.sub": "Merci de nous avoir contactés. Un membre de notre équipe vous contactera dans les 24 heures pour discuter de votre projet.",

  // Final CTA
  "cta.eyebrow": "Prêt à Construire ?",
  "cta.title1": "Votre Projet Mérite",
  "cta.title2": "une Équipe qui Livre.",
  "cta.sub": "Que vous démarriez un nouveau développement ou que vous mainteniez une infrastructure critique, KIVE SARL apporte l'expertise, l'équipement et la responsabilité pour le faire correctement. Parlons de votre projet aujourd'hui.",
  "cta.btn.consult": "Demander une Consultation Gratuite",
  "cta.badge1": "Devis Sans Engagement",
  "cta.badge2": "Réponse en 24h",
  "cta.badge3": "Équipe d'Experts",

  // Video section
  "video.eyebrow": "Nous en Action",
  "video.title": "Machinerie Lourde, Mains Professionnelles.",
  "video.body": "Regardez notre équipe opérer des équipements lourds d'excavation sur un chantier réel au Cameroun. Opérateurs certifiés, flotte entretenue, zéro temps d'arrêt.",
  "video.bullet1": "Opérateurs certifiés sur chaque machine",
  "video.bullet2": "Flotte disponible en location courte et longue durée",
  "video.cta": "Voir les Services Machinerie",

  // FAQ section
  "faq.eyebrow": "Questions",
  "faq.title": "Questions Fréquentes",
  "faq.sub": "Tout ce que vous devez savoir avant de nous contacter.",

  // Blog page
  "blog.hero.eyebrow": "Blog & Insights",
  "blog.hero.title": "Conseils de Construction et Études de Cas",
  "blog.hero.sub": "Conseils pratiques, guides réglementaires et analyses de coûts pour construire intelligemment au Cameroun.",
  "blog.featured": "Articles en Vedette",
  "blog.all": "Tous les Articles",
  "blog.cta.title": "Besoin de Conseils Personnalisés ?",
  "blog.cta.sub": "Notre équipe d'ingénieurs est prête à répondre à vos questions et à vous guider.",
  "blog.cta.btn": "Contactez un Expert",
  "blog.readMore": "Lire la Suite",

  // Brochure page
  "brochure.hero.eyebrow": "Profil de l'Entreprise",
  "brochure.hero.title": "Téléchargez Notre Brochure de Services",
  "brochure.hero.sub": "Obtenez notre profil d'entreprise complet en PDF — services, portfolio de projets, aperçu de l'équipe et coordonnées.",
  "brochure.form.name": "Nom Complet",
  "brochure.form.email": "Adresse Email",
  "brochure.form.company": "Entreprise / Organisation",
  "brochure.form.projectType": "Type de Projet",
  "brochure.form.submit": "Envoyez-moi la Brochure",
  "brochure.form.sending": "Envoi en cours...",
  "brochure.success.title": "Votre brochure est en route !",
  "brochure.success.sub": "Vérifiez votre boîte de réception sous 24 heures. Si vous ne la recevez pas, écrivez à info@kive-cm.com.",
  "brochure.noForm": "Veuillez nous écrire directement à info@kive-cm.com",
  "brochure.trust.noSpam": "Jamais de spam",
  "brochure.trust.clients": "Utilisé par 80+ clients",
  "brochure.trust.languages": "Disponible en Français & Anglais",

  // Questionnaire page
  "questionnaire.hero.eyebrow": "Devis Gratuit",
  "questionnaire.hero.title": "Quel Type de Projet Avez-Vous ?",
  "questionnaire.hero.sub": "Répondez à quelques questions rapides et notre équipe vous préparera une proposition personnalisée.",
  "questionnaire.step1": "Votre projet",
  "questionnaire.step2": "Vos coordonnées",
  "questionnaire.step3": "Envoyer",
  "questionnaire.form.projectType": "Type de Projet",
  "questionnaire.form.location": "Localisation du Projet",
  "questionnaire.form.budget": "Budget Approximatif",
  "questionnaire.form.timeline": "Calendrier Souhaité",
  "questionnaire.form.description": "Description du Projet",
  "questionnaire.form.name": "Nom Complet",
  "questionnaire.form.email": "Adresse Email",
  "questionnaire.form.phone": "Numéro de Téléphone",
  "questionnaire.form.company": "Entreprise / Organisation",
  "questionnaire.form.submit": "Demander un Devis",
  "questionnaire.form.sending": "Envoi en cours...",
  "questionnaire.form.back": "Retour",
  "questionnaire.form.continue": "Continuer",
  "questionnaire.success.title": "Demande Envoyée !",
  "questionnaire.success.sub": "Merci ! Notre équipe examinera votre projet et vous contactera sous 24 heures avec une proposition personnalisée.",
  "questionnaire.noForm": "Veuillez nous écrire directement à info@kive-cm.com",

  // Site Visit Banner
  "siteVisit.eyebrow": "Visite de Chantier Gratuite",
  "siteVisit.title": "Pas Sûr Par Où Commencer ? Nous Venons À Vous.",
  "siteVisit.body": "Nos ingénieurs visitent votre terrain — à Yaoundé — sans frais et sans engagement. Nous évaluons les conditions et répondons à vos questions avant tout engagement.",
  "siteVisit.cta": "Réserver une Visite Gratuite",
  "siteVisit.tagline1": "Sans frais. Sans engagement.",
  "siteVisit.tagline2": "Yaoundé et environs.",

  // Contact section alternative
  "contact.alt.divider": "— ou —",
  "contact.alt.cta": "Réserver une Visite Gratuite",

  // Footer
  "footer.desc": "Services agréés de gestion de construction, maintenance technique et location de matériel lourd à Yaoundé, Cameroun. Reconnu par les gouvernements, institutions et clients privés depuis 2007. Appelez le (+237) 677-009-408.",
  "footer.links": "Liens Rapides",
  "footer.newsletter.title": "Restez Informé",
  "footer.newsletter.sub": "Recevez les mises à jour de projets et les insights construction de notre équipe.",
  "footer.newsletter.placeholder": "Votre adresse email",
  "footer.newsletter.btn": "S'abonner",
  "footer.newsletter.subscribing": "Abonnement...",
  "footer.newsletter.done": "Vous êtes abonné. Merci !",
  "footer.copyright": "© 2026 KIVE SARL. Tous droits réservés. Yaoundé, Cameroun.",

  // Cookie Consent
  "cookieConsent.label": "Consentement aux cookies",
  "cookieConsent.message": "Ce site utilise des cookies pour assurer la fonctionnalité essentielle et améliorer votre expérience. En continuant à naviguer, vous acceptez notre utilisation des cookies.",
  "cookieConsent.accept": "Accepter",
  "cookieConsent.dismiss": "Refuser",
  "cookieConsent.learnMore": "Politique de Confidentialité",

  // Calculator page
  "calc.hero.badge": "Outil Gratuit",
  "calc.hero.title1": "Calculateur de Coût",
  "calc.hero.title2": "de Construction",
  "calc.hero.sub": "Obtenez une estimation réaliste du coût de construction pour votre projet au Cameroun en moins de 2 minutes. Adapté aux prix locaux de la main-d'œuvre et des matériaux.",
  "calc.hero.badge1": "Résultats en 2 minutes",
  "calc.hero.badge2": "Prix Cameroun",
  "calc.hero.badge3": "Coûts en FCFA",
  "calc.step.type": "Type",
  "calc.step.size": "Taille",
  "calc.step.spec": "Specs",
  "calc.step.location": "Lieu",
  "calc.step.extras": "Extras",
  "calc.type.title": "Que construisez-vous ?",
  "calc.type.sub": "Sélectionnez le type de bâtiment que vous planifiez.",
  "calc.size.title": "Quelle est la taille de votre projet ?",
  "calc.size.sub": "Entrez la surface par niveau et le nombre d'étages.",
  "calc.size.area": "Surface par niveau :",
  "calc.size.areaNote": "Il s'agit de la surface construite par étage, pas de la superficie du terrain.",
  "calc.size.floors": "Nombre d'Étages",
  "calc.size.bedrooms": "Nombre de Chambres",
  "calc.spec.title": "Spécifications",
  "calc.spec.sub": "Choisissez le niveau de finition, le type de fondation et la toiture.",
  "calc.spec.finish": "Niveau de Finition",
  "calc.spec.foundation": "Type de Fondation",
  "calc.spec.roof": "Type de Toiture",
  "calc.location.title": "Où construisez-vous ?",
  "calc.location.sub": "La localisation influence les coûts de main-d'œuvre, de transport et la disponibilité des matériaux.",
  "calc.extras.title": "Des extras ?",
  "calc.extras.sub": "Sélectionnez les équipements supplémentaires à inclure dans votre estimation.",
  "calc.extras.pool": "Piscine",
  "calc.extras.fence": "Clôture & Portail",
  "calc.extras.generator": "Groupe Électrogène",
  "calc.extras.borehole": "Forage / Puits",
  "calc.extras.note.title": "Note :",
  "calc.extras.note.body": "Les coûts des extras sont des moyennes approximatives pour le Cameroun. Les coûts réels dépendent de la taille, de la profondeur et du fournisseur.",
  "calc.nav.back": "Retour",
  "calc.nav.next": "Suivant",
  "calc.nav.calculate": "Calculer le Coût",
  "calc.results.estimatedCost": "Coût Total Estimé",
  "calc.results.totalArea": "surface construite totale",
  "calc.results.floors": "étage(s)",
  "calc.results.beds": "chambre(s)",
  "calc.results.breakdown": "Décomposition des Coûts",
  "calc.results.foundation": "Fondations",
  "calc.results.structure": "Structure & Toiture",
  "calc.results.electrical": "Travaux Électriques",
  "calc.results.plumbing": "Plomberie & Sanitaires",
  "calc.results.finishing": "Finitions & Équipements",
  "calc.results.extras": "Extras & Ajouts",
  "calc.results.contingency": "Imprévus (12%)",
  "calc.results.total": "Estimation Totale",
  "calc.results.disclaimer.title": "Avertissement",
  "calc.results.disclaimer.body": "Cette estimation est basée sur les données de construction 2025/2026 au Cameroun. Les coûts réels dépendent des conditions du sol, des prix des matériaux, de l'accès au chantier et des tarifs des entrepreneurs. Faites toujours établir un Devis Quantitatif formel par un métreur qualifié avant de vous engager sur un budget.",
  "calc.results.cta.title": "Obtenir un Devis Précis",
  "calc.results.cta.sub": "Notre équipe peut fournir un plan de coûts détaillé et spécifique à votre site. Contactez-nous pour une consultation gratuite.",
  "calc.results.cta.btn": "Demander une Consultation Gratuite",
  "calc.results.facts.title": "Bon à Savoir",
  "calc.results.facts.f1": "Les prix des matériaux au Cameroun peuvent fluctuer de 10 à 20 % selon les saisons — bloquez les prix tôt.",
  "calc.results.facts.f2": "Une provision pour imprévus de 12 % est la pratique standard pour les projets de construction camerounais.",
  "calc.results.facts.f3": "Douala coûte généralement 5 à 10 % de plus que Yaoundé en raison d'une demande de main-d'œuvre plus élevée.",
  "calc.results.facts.f4": "Les honoraires professionnels (architecte, ingénieur, métreur) ne sont pas inclus — prévoyez 8 à 12 % supplémentaires.",
  "calc.results.recalculate": "Nouvelle Estimation",
  "calc.faq.eyebrow": "Questions",
  "calc.faq.title": "Questions Fréquemment Posées",
  "calc.faq.q1": "Quelle est la précision de cette estimation ?",
  "calc.faq.a1": "Ce calculateur fournit une estimation approximative basée sur des données réelles de construction au Cameroun 2025/2026. Attendez-vous à une précision de ±20–30 %. Pour un budget précis, vous avez besoin d'un Devis Quantitatif formel d'un métreur qualifié.",
  "calc.faq.q2": "Est-ce que cela inclut le coût du terrain ?",
  "calc.faq.a2": "Non. L'achat du terrain, les frais de titrage et les coûts de préparation du terrain ne sont pas inclus. Ceux-ci varient énormément selon l'emplacement et doivent être budgétisés séparément.",
  "calc.faq.q3": "Qu'en est-il des honoraires professionnels ?",
  "calc.faq.a3": "Les honoraires d'architecte, d'ingénieur en structure et de métreur ne sont pas inclus. Prévoyez 8 à 12 % supplémentaires du coût de construction pour les services professionnels.",
  "calc.faq.q4": "Pourquoi y a-t-il une provision pour imprévus de 12 % ?",
  "calc.faq.a4": "Le marché de la construction au Cameroun connaît une volatilité des prix des matériaux, des retards dans la chaîne d'approvisionnement et des conditions de chantier imprévues. 12 % est la réserve standard recommandée par les métreurs locaux.",
  "calc.faq.q5": "Pourquoi la localisation change-t-elle le prix ?",
  "calc.faq.a5": "Les taux de main-d'œuvre, les coûts de transport et la disponibilité des matériaux diffèrent significativement entre Yaoundé, Douala, les villes provinciales et les zones rurales.",
  "calc.faq.q6": "Que faire après avoir obtenu cette estimation ?",
  "calc.faq.a6": "Contactez un architecte agréé pour concevoir votre bâtiment, puis faites établir un Devis Quantitatif détaillé. KIVE SARL peut gérer l'ensemble de ce processus — contactez-nous pour une consultation gratuite.",
  "calc.faq.q7": "Quel est le délai de livraison d'un projet typique ?",
  "calc.faq.a7": "Les délais varient selon la taille et la complexité du projet. Une maison individuelle prend généralement 6 à 12 mois, tandis qu'un immeuble de plusieurs étages peut prendre 18 à 36 mois. Un projet de maintenance peut être accompli en quelques jours à quelques semaines.",
  "calc.faq.q8": "Proposez-vous des contrats de maintenance annuels ?",
  "calc.faq.a8": "Oui, nous proposons des contrats de maintenance annuels adaptés aux besoins spécifiques de chaque client. Ces contrats couvrent la maintenance préventive et corrective, les inspections régulières et l'assistance technique prioritaire.",
  "calc.faq.q9": "Quels types de machines proposez-vous à la location ?",
  "calc.faq.a9": "Nous proposons une gamme complète incluant des pelleteuses, des bulldozers, des grues, des camions-bennes et des malaxeurs à béton. Tous nos équipements sont entretenus régulièrement et opérés par des opérateurs certifiés.",
  "calc.faq.q10": "Comment puis-je obtenir un devis ?",
  "calc.faq.a10": "Vous pouvez demander un devis via notre formulaire en ligne, par email à info@kive-cm.com, ou par téléphone au (+237) 677-009-408. Nous répondons généralement sous 24 heures.",
  "calc.faq.q11": "Travaillez-vous en dehors de Yaoundé ?",
  "calc.faq.a11": "Oui, nous intervenons dans tout le Cameroun et dans la région CEMAC. Nous avons déjà réalisé des projets à Douala, Bafoussam, Bamenda et au Gabon.",
  "calc.faq.q12": "Quels types de projets avez-vous déjà réalisés ?",
  "calc.faq.a12": "Nous avons réalisé plus de 80 projets incluant des villas résidentielles, des immeubles d'appartements, des écoles, des bureaux, des centres commerciaux et des infrastructures publiques.",

  // Services page
  "servicesPage.hero.eyebrow": "Ce Que Nous Offrons",
  "servicesPage.hero.title": "Services Experts pour Chaque Étape de Votre Projet",
  "servicesPage.hero.sub": "Du démarrage à la maintenance à long terme — KIVE SARL offre des services de construction et techniques complets à travers le Cameroun.",
  "servicesPage.overview": "Aperçu",
  "servicesPage.scope": "Périmètre d'Intervention",
  "servicesPage.sectors": "Secteurs Desservis",
  "servicesPage.faq": "Questions Fréquentes",
  "servicesPage.quoteBtn": "Demander un Devis",
  "servicesPage.quoteModal.title": "Demander un Devis",
  "servicesPage.quoteModal.close": "Fermer",

  // Projects page
  "projectsPage.hero.eyebrow": "Nos Réalisations",
  "projectsPage.hero.title1": "Des Projets Qui",
  "projectsPage.hero.title2": "Parlent d'Eux-Mêmes.",
  "projectsPage.hero.sub": "Des villas résidentielles aux campus institutionnels et aux travaux d'infrastructure — chaque projet de notre portefeuille reflète notre engagement envers la qualité, la précision et la livraison dans les délais à travers le Cameroun.",
  "projectsPage.gallery.eyebrow": "Portefeuille",
  "projectsPage.gallery.title": "Projets Sélectionnés",
  "projectsPage.cta.title": "Vous Avez un Projet en Tête ?",
  "projectsPage.cta.sub": "Parlez-nous de votre projet et nous vous répondrons avec une proposition sur mesure dans les 48 heures.",
  "projectsPage.cta.btn": "Demander un Devis Gratuit",
  "projectsPage.modal.location": "Localisation",
  "projectsPage.modal.year": "Année",
  "projectsPage.modal.client": "Client",
  "projectsPage.modal.scope": "Périmètre",
  "projectsPage.modal.type": "Type",
  "projectsPage.modal.discuss": "Discuter d'un Projet Similaire",

  // Careers page
  "careersPage.hero.badge": "Nous Recrutons",
  "careersPage.hero.title1": "Construisez le Cameroun.",
  "careersPage.hero.title2": "Construisez Votre Carrière.",
  "careersPage.hero.sub": "KIVE SARL est en pleine croissance. Nous recherchons des professionnels qualifiés et motivés — des ingénieurs et architectes aux artisans et chefs de chantier — pour rejoindre notre équipe à Yaoundé et au-delà.",
  "careersPage.hero.viewRoles": "Voir les Postes Ouverts",
  "careersPage.hero.submitCV": "Soumettre votre CV",
  "careersPage.why.eyebrow": "Pourquoi KIVE SARL",
  "careersPage.why.title1": "Plus qu'un Emploi.",
  "careersPage.why.title2": "Une Carrière qui Construit Quelque Chose de Réel.",
  "careersPage.why.sub": "Chez KIVE SARL, nous croyons que nos collaborateurs sont le fondement de chaque projet que nous livrons. Nous offrons un environnement professionnel et respectueux où les compétences sont reconnues, la croissance est soutenue et chaque membre joue un rôle significatif.",
  "careersPage.why.joinBtn": "Rejoindre Notre Équipe",
  "careersPage.roles.eyebrow": "Postes Ouverts",
  "careersPage.roles.title": "Opportunités Actuelles",
  "careersPage.roles.sub": "Nous recrutons activement dans plusieurs disciplines. Si votre profil ne figure pas ci-dessous, nous vous encourageons à soumettre une candidature spontanée.",
  "careersPage.roles.responsibilities": "Responsabilités Clés",
  "careersPage.roles.requirements": "Ce Que Nous Recherchons",
  "careersPage.roles.applyBtn": "Postuler pour ce Poste",
  "careersPage.form.eyebrow": "Postuler Maintenant",
  "careersPage.form.title1": "Prêt à Rejoindre",
  "careersPage.form.title2": "Notre Équipe ?",
  "careersPage.form.sub": "Remplissez le formulaire et nous examinerons votre candidature personnellement. Que vous soyez un ingénieur expérimenté ou un artisan qualifié, nous voulons vous entendre.",
  "careersPage.form.emailLabel": "Candidatures",
  "careersPage.form.emailNote": "Préférez-vous postuler par email ? Envoyez votre CV et une lettre de motivation à notre équipe RH. Nous répondons à toutes les candidatures dans les 5 jours ouvrables.",
  "careersPage.form.nextTitle": "Que Se Passe-t-il Ensuite ?",
  "careersPage.form.step1": "Nous examinons votre candidature dans les 5 jours ouvrables",
  "careersPage.form.step2": "Les candidats présélectionnés sont contactés pour un entretien téléphonique",
  "careersPage.form.step3": "Une évaluation technique ou pratique peut suivre",
  "careersPage.form.step4": "Les candidats retenus reçoivent une offre formelle de notre équipe RH",
  "careersPage.form.formTitle": "Formulaire de Candidature",
  "careersPage.form.required": "Les champs marqués * sont obligatoires.",
  "careersPage.form.firstName": "Prénom",
  "careersPage.form.lastName": "Nom de Famille",
  "careersPage.form.email": "Adresse Email",
  "careersPage.form.phone": "Numéro de Téléphone",
  "careersPage.form.position": "Poste Souhaité",
  "careersPage.form.positionPlaceholder": "Sélectionner un poste...",
  "careersPage.form.experience": "Années d'Expérience",
  "careersPage.form.location": "Localisation Actuelle",
  "careersPage.form.portfolio": "Profil LinkedIn ou URL Portfolio",
  "careersPage.form.coverLetter": "Lettre de Motivation / Message",
  "careersPage.form.cvNote": "Pour partager votre CV, envoyez-le directement à careers@kive-cm.com avec votre nom et le poste souhaité en objet.",
  "careersPage.form.submit": "Soumettre la Candidature",
  "careersPage.form.submitting": "Envoi en cours...",
  "careersPage.form.successTitle": "Candidature Reçue !",
  "careersPage.form.successSub": "Merci pour votre intérêt à rejoindre KIVE SARL. Nous avons bien reçu votre candidature et vous contacterons dans les 5 jours ouvrables.",

  "legal.privacy": "Politique de Confidentialité",

  // About page
  "about.hero.eyebrow": "À Propos de KIVE SARL",
  "about.hero.title1": "Bâti sur l'Expertise.",
  "about.hero.title2": "Animé par les Résultats.",
  "about.hero.sub": "Depuis 2007, KIVE SARL façonne l'environnement bâti du Cameroun — livrant des projets complexes de construction et de maintenance pour les gouvernements, les institutions et les clients privés à travers le pays et au-delà.",
  "about.story.eyebrow": "Notre Histoire",
  "about.story.title": "Un Bureau d'Études Bâti sur la Responsabilité",
  "about.story.p1": "KIVE SARL a été fondé à Yaoundé avec une mission simple mais ambitieuse : élever le standard de livraison de la construction au Cameroun. Au cours de près de deux décennies, nous sommes passés d'un entrepreneur local à une entreprise de services techniques multidisciplinaire reconnue par les clients les plus exigeants du pays — y compris les agences gouvernementales, les ONG internationales et les principaux promoteurs privés.",
  "about.story.p2": "Notre approche a toujours été la même : une planification rigoureuse, une communication transparente et une qualité sans compromis à chaque étape. Nous ne coupons pas les coins. Nous ne faisons pas de promesses excessives. Nous livrons.",
  "about.people.eyebrow": "Notre Équipe",
  "about.people.title": "Les Gens Derrière Chaque Projet",
  "about.people.p": "Derrière chaque projet réussi se trouve une équipe de professionnels dévoués. Nos ingénieurs, chefs de projet, superviseurs de chantier et personnel technique apportent des décennies d'expérience combinée à chaque travail. Nous investissons dans la formation, promouvons de l'intérieur et bâtissons des carrières — pas seulement des bâtiments.",
  "about.values.eyebrow": "Notre Méthode",
  "about.values.title": "Valeurs Qui Guident Chaque Projet",
  "about.values.accountability": "Responsabilité",
  "about.values.accountability.desc": "Nous assumons chaque décision et chaque résultat de nos projets.",
  "about.values.innovation": "Innovation",
  "about.values.innovation.desc": "Nous recherchons continuellement de meilleures méthodes, matériaux et processus.",
  "about.values.integrity": "Intégrité",
  "about.values.integrity.desc": "Communication transparente avec les clients, les partenaires et les régulateurs.",
  "about.values.excellence": "Excellence",
  "about.values.excellence.desc": "Aucun raccourci. Chaque livrable répond ou dépasse les spécifications.",
  "about.stats.experience": "Années d'Expérience",
  "about.stats.projects": "Projets Livrés",
  "about.stats.services": "Services Principaux",
  "about.stats.satisfaction": "Satisfaction Client",
  "about.cta.title": "Prêt à Travailler avec Nous ?",
  "about.cta.sub": "Que vous ayez un cahier des charges détaillé ou simplement une idée, notre équipe est prête à discuter de votre projet et à vous apporter des conseils d'experts.",
  "about.cta.btn": "Contacter Notre Équipe",

  // Contact page
  "contact.hero.eyebrow": "Contactez-Nous",
  "contact.hero.title1": "Contactez KIVE SARL",
  "contact.hero.title2": "Yaoundé, Cameroun",
  "contact.hero.sub": "Prêt à démarrer votre projet de construction ou de maintenance ? Contactez-nous par téléphone, WhatsApp, email ou via le formulaire ci-dessous. Notre équipe répond dans les 24 heures.",
  "contact.info.office": "Bureau",
  "contact.info.phone": "Téléphone",
  "contact.info.phone2": "Téléphone 2",
  "contact.info.whatsapp": "WhatsApp",
  "contact.info.email": "Email",
  "contact.info.hours": "Heures d'Ouverture",
  "contact.form.title": "Contacter KIVE SARL",
  "contact.form.emailAlt": "Veuillez nous contacter directement à",
  "contact.form.whatsappBtn": "Nous écrire sur WhatsApp",
  "contact.form.successTitle": "Message Reçu",
  "contact.form.successSub": "Merci de nous avoir contactés. Un membre de notre équipe vous contactera dans les 24 heures pour discuter de votre projet.",
  "contact.form.name": "Nom Complet",
  "contact.form.email": "Adresse Email",
  "contact.form.phone": "Numéro de Téléphone",
  "contact.form.subject": "Sujet",
  "contact.form.message": "Message",
  "contact.form.send": "Envoyer le Message",
  "contact.form.sending": "Envoi en cours...",
  "contact.cta.title": "Vous Préférez Appeler ? Nous Sommes Là.",
  "contact.cta.sub": "Nos chefs de projet sont disponibles du lundi au samedi pour discuter de vos besoins en construction, maintenance ou location de machinerie.",

  // Services page
  "services.hero.eyebrow": "Ce Que Nous Offrons",
  "services.hero.title": "Nos Services",
  "services.hero.sub": "Quatre disciplines clés livrées par une équipe responsable. Sélectionnez un service ci-dessous pour explorer le périmètre complet, les capacités et demander un devis.",
  "services.tab.construction": "Gestion de Construction",
  "services.tab.maintenance": "Maintenance Technique",
  "services.tab.machinery": "Location de Machinerie Lourde",
  "services.tab.sourcing": "Sourcing de Machinerie",
  "services.breadcrumb.home": "Accueil",
  "services.breadcrumb.services": "Services",
  "services.detail.overview": "Aperçu",
  "services.detail.scope": "Périmètre d'Intervention",
  "services.detail.sectors": "Secteurs Desservis",
  "services.detail.faq": "Questions Fréquentes",
  "services.detail.quoteBtn": "Demander un Devis",
  "services.detail.phoneBtn": "Nous Appeler",
  "services.detail.cta.title": "Prêt à démarrer ?",
  "services.detail.cta.sub": "Remplissez notre formulaire de devis et un chef de projet vous répondra dans les 24 heures.",
  "services.quoteModal.title": "Demander un Devis",
  "services.quoteModal.close": "Fermer",

  // Projects page
  "projects.hero.eyebrow": "Nos Réalisations",
  "projects.hero.title1": "Des Projets Qui",
  "projects.hero.title2": "Parlent d'Eux-Mêmes.",
  "projects.hero.sub": "Des villas résidentielles aux campus institutionnels et aux travaux d'infrastructure — chaque projet de notre portefeuille reflète notre engagement envers la qualité, la précision et la livraison dans les délais à travers le Cameroun.",
  "projects.stats.projects": "Projets Livrés",
  "projects.stats.years": "Années d'Activité",
  "projects.stats.sectors": "Secteurs de Service",
  "projects.stats.satisfaction": "Satisfaction Client",
  "projects.gallery.eyebrow": "Portefeuille",
  "projects.gallery.title": "Projets Sélectionnés",
  "projects.gallery.category.all": "Tous",
  "projects.cta.title": "Vous Avez un Projet en Tête ?",
  "projects.cta.sub": "Parlez-nous de votre projet et nous vous répondrons avec une proposition sur mesure dans les 48 heures.",
  "projects.cta.btn": "Demander un Devis Gratuit",
  "projects.modal.location": "Localisation",
  "projects.modal.year": "Année",
  "projects.modal.client": "Client",
  "projects.modal.scope": "Périmètre",
  "projects.modal.type": "Type",
  "projects.modal.discuss": "Discuter d'un Projet Similaire",
  "projects.featured": "En Vedette",
  "projects.imageCount": "images",

  // Careers page
  "careers.hero.badge": "Nous Recrutons",
  "careers.hero.title1": "Construisez le Cameroun.",
  "careers.hero.title2": "Construisez Votre Carrière.",
  "careers.hero.sub": "KIVE SARL est en pleine croissance. Nous recherchons des professionnels qualifiés et motivés — des ingénieurs et architectes aux artisans et chefs de chantier — pour rejoindre notre équipe à Yaoundé et au-delà.",
  "careers.hero.viewRoles": "Voir les Postes Ouverts",
  "careers.hero.submitCV": "Soumettre votre CV",
  "careers.why.eyebrow": "Pourquoi KIVE SARL",
  "careers.why.title1": "Plus qu'un Emploi.",
  "careers.why.title2": "Une Carrière qui Construit Quelque Chose de Réel.",
  "careers.why.sub": "Chez KIVE SARL, nous croyons que nos collaborateurs sont le fondement de chaque projet que nous livrons. Nous offrons un environnement professionnel et respectueux où les compétences sont reconnues, la croissance est soutenue et chaque membre joue un rôle significatif dans la construction du Cameroun.",
  "careers.why.joinBtn": "Rejoindre Notre Équipe",
  "careers.roles.eyebrow": "Postes Ouverts",
  "careers.roles.title": "Opportunités Actuelles",
  "careers.roles.sub": "Nous recrutons activement dans plusieurs disciplines. Si votre profil ne figure pas ci-dessous, nous vous encourageons à soumettre une candidature spontanée — nous voulons toujours entendre des professionnels talentueux.",
  "careers.roles.responsibilities": "Responsabilités Clés",
  "careers.roles.requirements": "Ce Que Nous Recherchons",
  "careers.roles.applyBtn": "Postuler pour ce Poste",
  "careers.form.eyebrow": "Postuler Maintenant",
  "careers.form.title1": "Prêt à Rejoindre",
  "careers.form.title2": "Notre Équipe ?",
  "careers.form.sub": "Remplissez le formulaire et nous examinerons votre candidature personnellement. Que vous soyez un ingénieur expérimenté ou un artisan qualifié, nous voulons vous entendre.",
  "careers.form.emailLabel": "Candidatures",
  "careers.form.emailNote": "Préférez-vous postuler par email ? Envoyez votre CV et une lettre de motivation à notre équipe RH directement. Nous répondons à toutes les candidatures dans les 5 jours ouvrables.",
  "careers.form.nextTitle": "Que Se Passe-t-il Ensuite ?",
  "careers.form.step1": "Nous examinons votre candidature dans les 5 jours ouvrables",
  "careers.form.step2": "Les candidats présélectionnés sont contactés pour un entretien téléphonique",
  "careers.form.step3": "Une évaluation technique ou pratique peut suivre",
  "careers.form.step4": "Les candidats retenus reçoivent une offre formelle de notre équipe RH",
  "careers.form.formTitle": "Formulaire de Candidature",
  "careers.form.required": "Les champs marqués * sont obligatoires.",
  "careers.form.firstName": "Prénom",
  "careers.form.lastName": "Nom de Famille",
  "careers.form.email": "Adresse Email",
  "careers.form.phone": "Numéro de Téléphone",
  "careers.form.position": "Poste Souhaité",
  "careers.form.positionPlaceholder": "Sélectionner un poste...",
  "careers.form.experience": "Années d'Expérience",
  "careers.form.location": "Localisation Actuelle",
  "careers.form.portfolio": "Profil LinkedIn ou URL Portfolio",
  "careers.form.coverLetter": "Lettre de Motivation / Message",
  "careers.form.cvNote": "Pour partager votre CV, envoyez-le directement à careers@kive-cm.com avec votre nom et le poste souhaité en objet.",
  "careers.form.submit": "Soumettre la Candidature",
  "careers.form.submitting": "Envoi en cours...",
  "careers.form.successTitle": "Candidature Reçue !",
  "careers.form.successSub": "Merci pour votre intérêt à rejoindre KIVE SARL. Nous avons bien reçu votre candidature et vous contacterons dans les 5 jours ouvrables.",

  // Blog detail
  "blog.backToBlog": "← Retour au Blog",
  "blog.readTime": "lecture",
  "blog.byLine": "Rédaction KIVE SARL",
  "blog.articleCTA.title": "Besoin d'Aide avec Votre Projet ?",
  "blog.articleCTA.sub": "Contactez notre équipe d'ingénieurs pour une consultation gratuite.",
  "blog.articleCTA.btn": "Parler à un Expert",
  "blog.related": "Articles Connexes",
  "blog.backToAll": "Retour à Tous les Articles",

  // Home components still hardcoded
  "home.services.eyebrow": "Nos Services",
  "home.services.title": "Ce Que Nous Faisons le Mieux",
  "home.services.sub": "Quatre disciplines clés. Une équipe responsable. Conçu pour les projets exigeants au Cameroun.",
  "home.services.detailsBtn": "Détails du Service",
  "home.services.quoteBtn": "Demander un Devis",
  "home.partners.eyebrow": "Ils Nous Font Confiance",
  "home.partners.title": "Partenaires & Clients",

  // Brochure
  "brochure.form.title": "Demandez la Brochure",
  "brochure.form.name": "Nom Complet",
  "brochure.form.email": "Adresse Email",
  "brochure.form.company": "Entreprise / Organisation",
  "brochure.form.projectType": "Type de Projet",
  "brochure.form.submit": "Envoyez-moi la Brochure",
  "brochure.form.sending": "Envoi en cours...",
  "brochure.success.title": "Votre brochure est en route !",
  "brochure.success.sub": "Vérifiez votre boîte de réception sous 24 heures. Si vous ne la recevez pas, écrivez à info@kive-cm.com.",
  "brochure.noForm": "Veuillez nous écrire directement à info@kive-cm.com",
  "brochure.trust.noSpam": "Jamais de spam",
  "brochure.trust.clients": "Utilisé par 80+ clients",
  "brochure.trust.languages": "Disponible en Français & Anglais",

  // Footer
  "footer.links": "Liens Rapides",
  "footer.newsletter.title": "Restez Informé",
  "footer.newsletter.sub": "Recevez les mises à jour de projets et les insights construction de notre équipe.",
  "footer.newsletter.placeholder": "Votre adresse email",
  "footer.newsletter.btn": "S'abonner",
  "footer.newsletter.subscribing": "Abonnement...",
  "footer.newsletter.done": "Vous êtes abonné. Merci !",
  "footer.copyright": "© 2026 KIVE SARL. Tous droits réservés. Yaoundé, Cameroun.",
  "footer.desc": "Services agréés de gestion de construction, maintenance technique et location de matériel lourd à Yaoundé, Cameroun. Reconnu par les gouvernements, institutions et clients privés depuis 2007. Appelez le (+237) 677-009-408.",
};

export default fr;
